import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="x"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="#000"
    {...props}
  >
    <path d="M14.286 10.164 23.222 0h-2.117l-7.763 8.823L7.147 0H0l9.37 13.343L0 24h2.117l8.192-9.32L16.853 24H24M2.88 1.562h3.253l14.97 20.953H17.85" />
  </svg>
);
export default SvgComponent;
